import { Job, JobType } from "./Context";

const isDependency = (job: Job): boolean => (
  job.type === JobType.MESSAGE_MEDIA_UPLOAD
  || job.type === JobType.TEST_JOB
);

export default isDependency;